import { render, staticRenderFns } from "./GeneralProductrecommendation.vue?vue&type=template&id=7b3b432a&scoped=true&"
import script from "./GeneralProductrecommendation.vue?vue&type=script&lang=js&"
export * from "./GeneralProductrecommendation.vue?vue&type=script&lang=js&"
import style0 from "./GeneralProductrecommendation.vue?vue&type=style&index=0&id=7b3b432a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b432a",
  null
  
)

export default component.exports